<template>
  <div>
    <div class="pdng-1">
      <div class="centered-row">
        <div class="loading">
          <Fai :icon="['far', 'circle-notch']" spin/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Loading',
    computed: {},
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";

  .loading {
    color: $red-2;
  }

</style>
